export const SET_ACTIVE_KEYWORDS = 'SET_ACTIVE_KEYWORDS';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

// Text Delta

export const ADD_DELTA = 'ADD_DELTA';
export const SET_DO_OUTPUT_DELTAS = 'SET_DO_OUTPUT_DELTAS';
export const CLEAR_DELTA_ARRAY = 'CLEAR_DELTA_ARRAY';

// Film Slider

export const SET_SLIDER_VALUE = 'SET_SLIDER_VALUE';
export const SET_FILM_SLIDER_PROJECT = 'SET_FILM_SLIDER_PROJECT';

// Moodboard

export const SET_PAUSE_UPDATE = 'SET_PAUSE_UPDATE';
export const SET_SELECTED_MOVIE = 'SET_SELECTED_MOVIE';
export const SET_BEAT_CONTAINER_HEIGHT = 'SET_BEAT_CONTAINER_HEIGHT';
export const SET_BEAT_LOADING_STATES = 'SET_BEAT_LOADING_STATES';
export const SET_IS_CHART_SHOWING = 'SET_IS_CHART_SHOWING';
export const SET_BEAT_DROPDOWN_OPTIONS = 'SET_BEAT_DROPDOWN_OPTIONS';
export const SET_BEAT_SEARCH_QUERY = 'SET_BEAT_SEARCH_QUERY';
export const SET_BEAT_QUERY = 'SET_BEAT_QUERY';
export const SET_BEAT_SELECTED_PHOTO = 'SET_BEAT_SELECTED_PHOTO';
export const SET_BEAT_PHOTOS = 'SET_BEAT_PHOTOS';
export const SET_EMOTION_DATA = 'SET_EMOTION_DATA';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js